(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('change', function (event) {
  var select = event.target;
  if (!select || typeof select.matches !== 'function') return;
  if (!select.matches('[data-localization-select]')) return;
  var form = select.closest('form');
  if (form) form.submit();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
/* Delegated submit-on-change for GET forms (sort select). Runs once. */
(function () {
  if (window.PSSPSubmitOnChange) return;
  window.PSSPSubmitOnChange = true;
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var form = target.closest('form[data-submit-on-change]');
    if (form && typeof form.submit === 'function') form.submit();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
